import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { editEducation } from "store/actions/adminEducationAction";
import { deleteEducation } from "store/actions/adminEducationAction";
import { getEducation } from "store/actions/adminEducationAction";
import { addEducation } from "store/actions/adminEducationAction";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const AdminEducation = () => {
  let dispatch = useDispatch();
  const [addEducationModal, setAddEducationModal] = useState(false);
  const [education, setEducation] = useState({
    url: "",
    title: "",
  });
  let [loader, setLoader] = useState({
    data: true,
    btn: false,
    delBtn: false,
    loadMore: false,
  });
  const [id, setId] = useState("");
  const [isEdit, setEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const { educationData, hasMoreEducation, lastDocumentOfEducation } =
    useSelector((state) => state.adminEducation);
  const infoPoints = [
    "This module helps the admin manage daily, weekly, and monthly operational tasks, including financial checks, user requests, store orders, strategy reviews, and platform growth planning",
  ];
  const subPoints = [];
  const infoTitle = "Admin Education Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const columns = ["Url", "Title", "Created At"];
  const keyMap = {
    Url: "url",
    Title: "title",
    "Created At": "created_at",
  };

  const formattedData = educationData.map((item) => ({
    ...item,
    title: item.title || "No Title",
    created_at: item?.createdAt?.seconds
      ? moment.unix(item.createdAt.seconds).format("MMMM Do YYYY")
      : "N/A",
  }));

  const renderActions = (row) => (
    <>
      <Button color="primary" size="sm" onClick={() => handleEdit(row)}>
        Edit
      </Button>{" "}
      <Button
        color="danger"
        size="sm"
        onClick={() => {
          deleteToggle();
          setId(row.id);
        }}
      >
        Delete
      </Button>{" "}
      <a
        href={row.url}
        className="btn btn-sm btn-success"
        target="_blank"
        rel="noopener noreferrer"
      >
        Watch
      </a>
    </>
  );

  useEffect(() => {
    dispatch(
      getEducation("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, {});
  const LoadMoreEducation = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getEducation(lastDocumentOfEducation, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    setEducation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const toggle = () => {
    setAddEducationModal(!addEducationModal);
    setEducation({
      url: "",
      title: "",
    });
  };
  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    if (isEdit) {
      let newData = {
        id: id,
        ...education,
      };
      dispatch(
        editEducation(newData, (res) => {
          setLoader((prev) => ({
            ...prev,
            btn: false,
          }));
          if (res !== "error") {
            toggle();
            setEdit(false);
          }
        })
      );
    } else {
      dispatch(
        addEducation(education, (res) => {
          setLoader((prev) => ({
            ...prev,
            btn: false,
          }));
          if (res !== "error") {
            toggle();
          }
        })
      );
    }
  };

  const handleDelete = () => {
    setLoader((prev) => ({
      ...prev,
      delBtn: true,
    }));
    dispatch(
      deleteEducation(id, (res) => {
        setLoader((prev) => ({
          ...prev,
          delBtn: false,
        }));
        if (res !== "error") {
          deleteToggle();
        }
      })
    );
  };
  const handleEdit = (obj) => {
    setEducation({
      url: obj.url,
      title: obj.title,
    });
    setAddEducationModal(true);
    setId(obj.id);
    setEdit(true);
  };

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <div className="d-flex justify-content-end align-items-center">
          <Button
            color="primary"
            className="mt-2 mb-0 mr-2"
            onClick={() => {
              setEdit(false);
              toggle();
            }}
          >
            Create/Add
          </Button>
          <h2
            className="mb-0 mt-1 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>
        </div>

        <Row className="my-4">
          <Col>
            <Card className="p-2">
              {loader.data ? (
                <div className="text-center my-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <TableComponent
                    columns={columns}
                    data={formattedData}
                    keyMap={keyMap}
                    renderActions={renderActions}
                  />

                  {/* <Table
                    className="align-items-center table-flush mt-3"
                    responsive
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Url
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Title
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Created At
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody className=" mt-3">
                      {educationData.length > 0 ? (
                        educationData.map((items, index) => {
                          return (
                            <tr key={index}>
                              <td className={`custom-table-text `}>
                                {items.url}
                              </td>
                              <td className={`custom-table-text `}>
                                {items.title}
                              </td>
                              <td className={`custom-table-text `}>
                                {moment
                                  .unix(items?.createdAt?.seconds)
                                  .format("MMMM Do YYYY")}
                              </td>
                              <td className={`custom-table-text `}>
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => handleEdit(items)}
                                >
                                  Edit
                                </Button>{" "}
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => {
                                    deleteToggle();
                                    setId(items.id);
                                  }}
                                >
                                  Delete
                                </Button>{" "}
                                <a
                                  href={items.url}
                                  className="btn btn-sm btn-success"
                                  size="sm"
                                  target="_blank"
                                >
                                  Watch
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td className={`custom-table-text `}>N/A</td>
                          <td className={`custom-table-text `}>N/A</td>
                          <td className={`custom-table-text `}>N/A</td>
                          <td className={`custom-table-text `}>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table> */}
                  {educationData.length > 4 && (
                    <div className="text-center py-4">
                      <Button
                        onClick={LoadMoreEducation}
                        color="primary"
                        disabled={loader.loadMore || !hasMoreEducation}
                      >
                        {loader.loadMore ? <Spinner size="sm" /> : "Load More"}{" "}
                      </Button>
                    </div>
                  )}
                </>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={addEducationModal} toggle={toggle} size="sm" centered>
        <h1 className="text-center mt-1 mb-0 p-2 pb-0">
          {isEdit ? "Update" : "ADD"} Education
        </h1>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="url">Url</Label>
              <Input
                type="text"
                name="url"
                id="url"
                placeholder="Enter video Url"
                value={education.url}
                onChange={handleChange}
                className="mb-3"
                required
              />
              <Label for="title">Title</Label>
              <Input
                type="text"
                name="title"
                id="title"
                placeholder="Enter Video Title"
                value={education.title}
                onChange={handleChange}
                className="mb-3"
                required
              />
            </FormGroup>
            <Row className="g-3">
              <Col xs={12} sm={6} md={6} className="mb-2 mb-sm-0">
                <Button color="primary" block>
                  {loader.btn ? (
                    <Spinner size="sm" />
                  ) : isEdit ? (
                    "Update"
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Col>
              <Col xs={12} sm={6} md={6} className="mb-2 mb-sm-0">
                <Button color="danger" onClick={toggle} block>
                  Close
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={deleteModal} centered toggle={deleteToggle}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to Delete.
            </span>
            <br />
            <br />
            <br />
            <Button color="primary" onClick={handleDelete}>
              {loader.delBtn ? <Spinner /> : "Yes"}
            </Button>
            <Button color="danger" onClick={deleteToggle}>
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AdminEducation;
